import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/header/header';
import './global.css';
import Loading from './pages/Loading/Loading';
import Welcome from './pages/Welcome/Welcome';
import Login from './pages/Login/Login';
import Home from './pages/Home/Home';
import AssetView from './pages/Home/AssetView';
import AssetDetail from './pages/Home/AssetDetail';
import Profile from './pages/Profile/Profile';
import CreateAsset from './pages/CreateAsset/CreateAsset';
import InterpretJSON from './pages/InterpretJSON/InterpretJSON'
import AssetsLoader from './features/assets/AssetsLoader'
import { getStorage } from './hooks/useAuth';
import './global.css';
import './assets/fonts/icomoon.css'
import './i18n';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';
import { fetchCurrentUser } from './store/user';

const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentUser } = useSelector((state: RootState) => state.currentUser);

  useEffect(() => {
    if (!currentUser && localStorage.getItem('access_token')) {
      dispatch(fetchCurrentUser());
    }
  }, [currentUser]);

  return (
    <>
      <AssetsLoader />
      <Routes>
        {/* Loading / Welcome Flow */}
        <Route path="/" element={<Loading />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />

        {/* Authenticated / Main App */}
        <Route path="/home" element={<Layout><Home /></Layout>} />
        <Route path="/profile" element={<Layout><Profile /></Layout>} />
        <Route path="/create-asset" element={<Layout><CreateAsset /></Layout>} />
        <Route path="/interpret-json" element={<Layout><InterpretJSON /></Layout>} />
        <Route path="/assets/:id" element={<Layout><AssetView /></Layout>} />
        <Route path="/assets/:id/detail" element={<Layout><AssetDetail /></Layout>} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
